import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@/translations';

Vue.use(VueI18n);
export const languageList = Object.keys(messages);

export default new VueI18n({
  locale: localStorage.getItem('language') || 'en',
  fallbackLocale: 'en',
  messages,
});
